module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Filter dashboard","input-1":"Pipeline","input-2":"From","input-3":"To","placeholder-1":"Select a pipeline","save":"Save updates"},"pt-BR":{"title":"Filtrar dashboard","input-1":"Pipeline","input-2":"De","input-3":"Até","placeholder-1":"Selecione um pipeline","save":"Salvar alterações"}}')
  delete Component.options._Ctor
}
